import { marketDataSnapshots } from './marketDataSnapshots'
import { mockPairs } from './mockPairs'
import { prices } from './prices'
import { pricingSimulation } from './pricingSimulation'
import { quoteReponses, quoteResponseState } from './quote'
import { socketMeta } from './socketMeta'
import { streamingTiles } from './streamingTiles'

const store = {
  marketDataSnapshots,
  mockPairs,
  prices,
  pricingSimulation,
  quoteReponses,
  quoteResponseState,
  socketMeta,
  streamingTiles,
}

export default store
